export default __webpack_public_path__ + "static/media/gear-1.96fc3775.png";